/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ContentBlock } from './content-block';
import { PreparedStatement, FootNote } from './prepared-statement';

export class ContentResponse {
    BLOCKS: ContentBlock[];
    PS_IBIS: PreparedStatement[];
    PS_GENERAL: PreparedStatement[];
    REFS: FootNote[];
    EFFECTIVE_DATE: string;

    // Helper
    HIGHLIGHT_BLOCKS: boolean;

    constructor(values: any = {}){
      Object.assign(this, values);

      if(values){
        if(values.BLOCKS)
          this.BLOCKS = ContentBlock.parseArray(values.BLOCKS);
        else
          this.BLOCKS = [];

        if(values.PS_IBIS)
          this.PS_IBIS = PreparedStatement.parseArray(values.PS_IBIS);
        else
          this.PS_IBIS = [];

        if(values.PS_GENERAL)
          this.PS_GENERAL = PreparedStatement.parseArray(values.PS_GENERAL);
        else
          this.PS_GENERAL = [];

        if(values.REFS)
          this.REFS = FootNote.parseArray(values.REFS);
        else
          this.REFS = [];
      }
    }
}

export interface response {
  result: ContentResponse,
  success: boolean
}
